export default {
  data() {
    return {
      entryTable: [],
      exitTable: [],
      stroageTable: [],
      entryTableTitle: [
        { prop: 'name', label: '进仓单号' },
        { prop: 'serviceProcess', label: '服务环节' },
        { prop: 'depotLevelServices', label: '仓库服务' },
        { prop: 'warehouseCategory', label: '仓库类别' }
      ],
      exitTableTitle: [
        { prop: 'name', label: '出仓单号或提单号' },
        { prop: 'serviceProcess', label: '服务环节' },
        { prop: 'depotLevelServices', label: '仓库服务' },
        { prop: 'warehouseCategory', label: '仓库类别' }
      ],
      // 服务环节列表
      serviceProcessList: [
        { id: '仓储', name: '仓储' },
        { id: '入库', name: '入库' },
        { id: '出库', name: '出库' }
      ],
      // 仓库服务列表
      warehouseServicesList: [
        { id: '入库操作', name: '入库操作'},
        { id: '出库操作', name: '出库操作'}
      ],
      // 仓库类别列表
      warehouseCategoryList: [
        { id: '操作量结算', name: '操作量结算' },
        { id: '存储量结算', name: '存储量结算' }
      ]
    }
  },
  created() {
  },
  methods: {
    /** 
     * @description 进出仓单信息列表
     * @param {Array} list 进出仓单信息列表
     * @param {number} status 进出仓单开票状态
     * @param {string} type 应付pay; 应收harvest
    */
    initEntryExitTable(list, status, type) {
      let arr = []
      let arr2 = []
      let arr3 = []
      list.map(i => {
        let obj = {}
        obj.id = i.id
        // true：同上；false：同下；
        obj.serviceProcessType = true
        // true：同上；false：同下；
        obj.depotLevelServicesType = true
        // true：同上；false：同下；
        obj.warehouseCategoryType = true
        obj.invoiceId = i.invoiceId
        obj.orderType = i.orderType
        obj.name = i.orderType === 2 ? i.orderNo : i.inboundOrderNo
        obj.inboundOrderNo = i.inboundOrderNo
        obj.orderNo = i.orderNo
        obj.outboundOrderNo = i.outboundOrderNo
        if (type === 'pay') {
          obj.serviceProcess = status === 11 ? (i.serviceProcess ? i.serviceProcess : '仓储') : i.serviceProcess
          obj.warehouseCategory = status === 11 ? (i.warehouseCategory ? i.warehouseCategory : '操作量结算') : i.warehouseCategory
        } else {
          obj.serviceProcess = status === 10 ? (i.serviceProcess ? i.serviceProcess : '仓储') : i.serviceProcess
          obj.warehouseCategory = status === 10 ? (i.warehouseCategory ? i.warehouseCategory : '操作量结算') : i.warehouseCategory
        }
        if (i.orderType === 2) {
          if (type === 'pay') {
            obj.depotLevelServices = status === 11 ? (i.depotLevelServices ? i.depotLevelServices :'出库操作') : i.depotLevelServices
          } else {
            obj.depotLevelServices = status === 10 ? (i.depotLevelServices ? i.depotLevelServices :'出库操作') : i.depotLevelServices
          }
          arr2.push(obj)
        } else if (i.orderType === 1) {
          if (type === 'pay') {
            obj.depotLevelServices = status === 11 ? (i.depotLevelServices ? i.depotLevelServices :'入库操作') : i.depotLevelServices
          } else {
            obj.depotLevelServices = status === 10 ? (i.depotLevelServices ? i.depotLevelServices :'入库操作') : i.depotLevelServices
          }
          arr.push(obj)
        } else {
          if (type === 'pay') {
            obj.depotLevelServices = status === 11 ? (i.depotLevelServices ? i.depotLevelServices : '入库操作') : i.depotLevelServices
          } else {
            obj.depotLevelServices = status === 10 ? (i.depotLevelServices ? i.depotLevelServices : '入库操作') : i.depotLevelServices
          }
          arr3.push(obj)
        }
      })
      this.entryTable = this.processType(arr);
      this.exitTable = this.processType(arr2);
      this.stroageTable = this.processType(arr3);

    },

    /** 
     * @desc 初始化同上/下类型
    */
    processType(arr) {
      if (arr.length) {
        arr[0].serviceProcessType = false
        arr[0].depotLevelServicesType = false
        arr[0].warehouseCategoryType = false
      }
      return arr
    }
  }
}